<!-- Mes billets content -->
<section id="mesbillets-content" style="margin-top: 20px">

  <div class="alert alert-info" role="alert"  style="text-align: center" *ngIf="loading"  >
    {{'front_profil_ticket.loading'| translate}}
  </div>

  <div class="alert alert-success" role="alert" *ngIf="downloadsucces && !downloaderror" style="text-align: center" >
    {{'front_profil_ticket.download_done_successfully'| translate}}
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="downloaderror && !downloadsucces" style="text-align: center">
    {{'front_profil_ticket.an_error_has_occured_please_try_again_later'| translate}}
  </div>

  <app-contact-form-modal   #contactFormModal>

  </app-contact-form-modal>

  <div class="flexible flex-just-center" *ngIf="viewdetail == 1 && ticket">
    <div class="wrapper">

      <div class="container rmp override-container">

        <app-order-show [order]="order"></app-order-show>

       <!-- <div class="orderDetail width-100" style="margin-bottom: 20px">
          <div class="width-100" style="flex-direction: row;">
            <div style="line-height: 30px">
              <span class="block width-100 TitilliumWeb-Regular" style="font-size: 18px"> {{'front_profil_ticket.order_for'| translate}}</span>
              <span class="block width-100 TitilliumWeb-Regular "  style="font-size: 24px;color: #0b7dda">{{order.event.name}}</span>
            </div>
            <span class="block width-100 TitilliumWeb-Regular ">{{order.event.start_date|datefrench}}  {{'front_profil_ticket.from'| translate}} {{order.event.start_hour |hourpipe}}  {{'front_profil_ticket.to'| translate}} {{order.event.end_hour |hourpipe}}</span>
            <span  class="block width-100 TitilliumWeb-Regular ">{{location(order)}}</span>
            <span class="block  width-100 TitilliumWeb-Regular ">{{'front_profil_ticket.order'| translate}} {{order.id}}</span>
          </div>
          <div class="width-100 text-right text-center-mini margin-top-20-mini " style="align-self: flex-end">
            <span style="display: block;text-transform: uppercase">statut de l'échéance</span>
            <span style="display: block">En cours</span>
            <a href="javascript:void(0);" class="btn1 btn2 action1 " style="color: white;margin-top: 15px;background-color: var(&#45;&#45;btn-bgColor);padding: 9px 14px;" (click)="openContactModal(order)"><span class="btnText">{{'front_profil_ticket.contact_the_organizer'| translate}}</span> </a>
          </div>
        </div>
-->
        <header class="flexible" id ="billetdetail">
          <h5 class="inline-block TitilliumWeb-Regular" >{{'front_profil_ticket.ticket_detail'| translate}} {{ticket.id}}</h5>
        </header>
        <div class="table-wrapper">
          <div class="width-100 table">

            <div class="table-row  width-100" style="text-align: right">
              <div class="columnheigh flexible">
                <div style="align-items: unset;width: unset!important">
                  <img src="{{ticket.qrcode}}" class="qrcode margin-auto-mini mini-qrcode-width" style="height: 180px;width: 180px" >
                </div>
                <div style="padding-right: 5%; width: 100%;" class="magin-right-25">

                <div class="block width-100 text-align-start padding-top-10-mini">
                  <label for="">Nom porteur</label>
                 <input class="form-control width-50 width-100-mini" style="text-align: left!important;" value="{{ticket.firstname}}"  #firstname="ngModel" required [(ngModel)]="ticket.firstname">
                       <div *ngIf="firstname.errors && (firstname.dirty ||firstname.touched)"  class="alert alert-danger">
                           <div [hidden]="!firstname.errors.required">
                             {{'front_profil_ticket.lastname_is_required'| translate}}
                           </div>
                       </div>
                </div>
                <div class="block width-100 text-align-start">
                  <label for="">Prénom porteur</label>
                 <input class="form-control width-50 width-100-mini" style="text-align: left!important;" value="{{ticket.lastname}}" #lastname="ngModel" required [(ngModel)]="ticket.lastname">
                         <div *ngIf="lastname.errors && (lastname.dirty ||lastname.touched)"  class="alert alert-danger">
                             <div [hidden]="!lastname.errors.required">
                               {{'front_profil_ticket.firstname_is_required'| translate}}
                             </div>
                       </div>
                </div>
                  <div style="text-align: center;margin-top: 20px;">
                    <a href="javascript:void(0);" style="color: white ;background-color: var(--btn-bgColor);padding: 4px 22px;" class="btn2 min-width-mini pointer1" (click)="update($event)">{{'front_profil_ticket.save'| translate}}</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="column flexible flex-1 savre" style="justify-content: center">
              <a href="javascript:void(0);" style="color: white;background-color: grey;padding: 6px 38px;" class="btn2" (click)="showtickets($event,order)"> {{'front_profil_ticket.back'| translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flexible flex-just-center" *ngIf="viewdetail == 2 && order">
    <div class="wrapper">
      <div class="container rmp override-container">
        <div class="table-wrapper">
          <div class="width-100 table">
            <div class="order-detail-label" *ngIf="orderIsPaid(order)">
              Détail commande N° {{order.id}}
            </div>

            <div class="order-detail-label" *ngIf="!orderIsPaid(order)">
              Réservation N° {{order.id}}
            </div>
          <app-order-show [order]="order" (contactClick)="openContactModal($event)"></app-order-show>
             <!-- <div class="orderDetail width-100">
                <div class="width-100" style="flex-direction: row;">
                  <div style="line-height: 30px">
                      <span class="block width-100 TitilliumWeb-Regular" style="font-size: 18px"> {{'front_profil_ticket.order_for'| translate}}</span>
                      <span class="block width-100 TitilliumWeb-Regular "  style="font-size: 24px;color: #0b7dda">{{order.event.name}}</span>
                  </div>
                      <span class="block width-100 TitilliumWeb-Regular ">{{order.event.start_date|datefrench}}  {{'front_profil_ticket.from'| translate}} {{order.event.start_hour|hourpipe}}  {{'front_profil_ticket.to'| translate}} {{order.event.end_hour |hourpipe}}</span>
                      <span  class="block width-100 TitilliumWeb-Regular ">{{location(order)}}</span>
                      <span class="block  width-100 TitilliumWeb-Regular ">{{'front_profil_ticket.order'| translate}} {{order.id}}</span>
                </div>
                <div class="width-100 text-right text-center-mini margin-top-20-mini" style="align-self: flex-end">
                      <a href="javascript:void(0);" class="btn1 btn2 action1 " style="color: white;margin-top: 15px;background-color: var(&#45;&#45;btn-bgColor);padding: 9px 14px;" (click)="openContactModal(order)"><span class="btnText">{{'front_profil_ticket.contact_the_organizer'| translate}}</span> </a>
                </div>
              </div>-->
              <!--<div style="border: 1px solid grey;height: 2px;margin-top: 30px;margin-bottom: 30px"></div>-->

              <div class="pading-5-50p">
                <div *ngFor="let ticket of order.tickets" style="vertical-align: middle;margin-top: 40px">
                  <div style="display: block;width: 100%">
                    <div  class="table-row ordertickets  width-100">
                    <span   class="inline-flexible ticketImg img-wrapper margin-auto-mini" *ngIf="ticket && orderIsPaid(order)" style="padding: 15px" >
                      <ng-container>
                          <img src="{{ticket.qrcode}}" class="qrcode margin-auto-mi mini-qrcode-width-2" style="height: 150px;width: 150px" >
                      </ng-container>
                    </span>

                      <span   class="inline-flexible ticketImg img-wrapper margin-auto-mini" *ngIf="ticket && !orderIsPaid(order)" style="padding: 15px" >
                      <ng-container>
                          <img src="assets/imgs/banner.png" class="qrcode margin-auto-mi mini-qrcode-width-2" style="height: 150px;width: 150px" >
                      </ng-container>
                    </span>

                      <div class="TitilliumWeb-Regular margin-auto-mini magin-middle magin-left--4 margin-bottom-10-mini">
                        <span>Porteur : <span style="font-family: TitilliumWeb-Black"> {{ticket.firstname+' '+ticket.lastname}}</span></span><br>
                        <span>Tarif: {{ticket.pricing.label}}</span><br>
                        <span>Prix: {{ticket.pricing.Totalprice}}</span>
                      </div>

                      <div class="btn-div margin-auto-mini" style="min-width: 160px;margin: auto">
                        <button  class="btn1 btn3 block  pointer1" style="background-color: var(--btn-bgColor);color: white;text-align: center;padding: 7px 47px;" (click)="detail($event,ticket.id)"> Modifier</button>
                        <button *ngIf="orderIsPaid(order)" class="btn1 btn3 block  pointer1" style="background-color:  var(--header-bgColor); color: white;text-align: center;padding: 7px 29px;" (click)="download($event,ticket.id)"><i class="fa fa-ticket"></i>{{'front_profil_ticket.download'| translate}}</button>
                      </div>

                    </div>

                    <!--<div style="width: 100%">
                      Vous pouvez aussi présenter ce écran depuis votre mobile
                    </div>-->
                  </div>

                </div>
              </div>
              <div class="flexible width-100" style="text-align: right">
               <div class="column flexible flex-1 savre" style="justify-content: center">
                  <a href="javascript:void(0);" class="back btn2 margin-top-20-min" (click)="tickets()"> {{'front_profil_ticket.back'| translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flexible flex-just-center" *ngIf="viewdetail==0">
    <div class="wrapper">
      <div class="my-ticket-bar">
        Mes billets
      </div>
      <div class="container rmp override-container">
        <div class="table-wrapper m-top-15p">
          <ul class="tabs heigh-40p flex-center">
            <li class="tab-link capitals bolder" data-tab="tab-1">{{'front_profil_ticket.past_event'| translate}}</li>
            <li><span class="event-past-future-separator"></span></li>
            <li class="tab-link capitals bolder current" data-tab="tab-2">{{'front_profil_ticket.future_event'| translate}}</li>
          </ul>
         <!-- <h5 class="inline-block">événement passé  et a venir</h5>-->
          <div id="tab-1" class="tab-content" style="padding-top: 20px;padding-bottom: 20px">
            <div *ngFor="let order of orders">
              <div class="table-row  width-100 margin-top-20-min"  *ngIf="order.event && order.event.end_date<(today|date: 'yyyy-MM-dd')" >
                <a  class="   width-100  billet-item ">
                  <div class="  div3 width-100">
                    <div class="ticket-flexible  billet billetTest " (click)="detailComande($event,order)">
                      <span  class="inline-flexible ticketImg img-wrapper max-width-unset-mini height-100">
                        <img src="{{order.event.image |assetimage}}" class="height-140px ticketimg1 border-left-radius" onError="this.src='assets/imgs/banner.png'">
                      </span>
                      <div *ngIf="order.event"  class="flexible  flexible-column billet-details margin-top-10-mini margin-bottom-10-mini  flex-1 height-100 margin-right_auto-mini padding-10-13p">
                        <h5 style="font-weight: bolder;align-self: unset;"  class="text-align-left-mini evtName eventNameMini  TitilliumWeb-Regular">{{order.event.name.length >35 ? order.event.name.substring(0, 35) : order.event.name}}</h5>
                        <span style="margin-bottom: 3px"  class="TitilliumWeb-Regular text-align-left-mini">{{order.event.start_date|datefrench}}</span>
                        <span style="margin-bottom: 3px"  class="TitilliumWeb-Regular text-align-left-mini">Commande {{order.id}}</span>
                        <a href="javascript:void(0);" class="btn1 btn2 action1 ticket-btn padding-top-6-mini" style="color: white;display: block;margin-right: auto" (click)="showtickets($event,order)" ><span class="btnText">{{'front_profil_ticket.tickets'| translate}}</span> </a>
                      </div>
                      <!--<div class="divaction" style="margin-left: 2px;align-self: center;">
                        &lt;!&ndash;<span class="block" >&ndash;&gt;

                        &lt;!&ndash;
                      <button type="submit" class="btn" style="color: white"  (click)="download($event,ticket.id)"><i class="fa fa-ticket"> Télécharger</i></button>
                       <button type="submit" class="btn" style="background-color: #0274b6;color: white"   (click)="detail($event,ticket.id)"><i class="fa fa-list"></i>Détail commande</button>&ndash;&gt;
                        &lt;!&ndash;<button type="submit" class="fab-btn btn-warning"(click)="resend($event,ticket.id)"><i class="fa fa-envelope"></i></button>&ndash;&gt;
                      </div>-->
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div *ngIf="j == 0" class="text-center">
              <h5 style="margin-bottom: 13px"  class="TitilliumWeb-Regular">{{'front_profil_ticket.you_have_no_past_event'| translate}}</h5>
              <a href="/" class="btn active TitilliumWeb-Regular" style="padding-left: 15px;padding-right: 15px"   role="button" aria-pressed="true"><i class="fa fa-calendar" aria-hidden="true" style="margin-right: 10px;color: white!important;"></i>{{'front_profil_ticket.check_the_agenda'| translate}}</a>
            </div>
          </div>
          <div id="tab-2" style="padding-top: 20px;padding-bottom: 20px" class="tab-content current">
            <div *ngFor="let order of orders">
              <div class="table-row  width-100 margin-top-20-min"  *ngIf="order.event && order.event.end_date>(today|date: 'yyyy-MM-dd')" >
                <a  class="   width-100  billet-item ">
                  <div class="  div3 width-100">
                    <div  class="ticket-flexible  billet billetTest" (click)="detailComande($event,order)">
                      <span  class="inline-flexible ticketImg img-wrapper max-width-unset-mini height-100">
                        <img src="{{order.event.image |assetimage}}" class="height-140px border-left-radius ticketimg1" onError="this.src='assets/imgs/banner.png'">
                      </span>
                      <div *ngIf="order.event"  class="flexible padding-10-13p  flexible-column billet-details margin-top-10-mini margin-bottom-10-mini  flex-1 height-100 margin-right_auto-mini">
                        <h5 style="font-weight:bolder;align-self: unset;"  class="text-align-left-mini evtName eventNameMini  TitilliumWeb-Regular">{{order.event.name.length >35 ? order.event.name.substring(0, 35) : order.event.name}}</h5>
                        <span style="margin-bottom: 3px"  class="TitilliumWeb-Regular text-align-left-mini">{{order.event.start_date|datefrench}}</span>
                        <span style="margin-bottom: 3px"  class="TitilliumWeb-Regular text-align-left-mini">Commande {{order.id}}</span>
                        <a href="javascript:void(0);" class="btn1 btn2 action1 ticket-btn padding-top-6-mini" style="color: white;display: block;margin-right: auto" (click)="showtickets($event,order)" ><span class="btnText">{{'front_profil_ticket.tickets'| translate}}</span> </a>
                      </div>
                      <!--<div class="divaction" style="margin-left: 2px;align-self: center;">
                        &lt;!&ndash;<span class="block" >&ndash;&gt;

                        &lt;!&ndash;
                      <button type="submit" class="btn" style="color: white"  (click)="download($event,ticket.id)"><i class="fa fa-ticket"> Télécharger</i></button>
                       <button type="submit" class="btn" style="background-color: #0274b6;color: white"   (click)="detail($event,ticket.id)"><i class="fa fa-list"></i>Détail commande</button>&ndash;&gt;
                        &lt;!&ndash;<button type="submit" class="fab-btn btn-warning"(click)="resend($event,ticket.id)"><i class="fa fa-envelope"></i></button>&ndash;&gt;
                      </div>-->
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div *ngIf="k == 0" class="text-center">
              <h5 style="margin-bottom: 13px" class="TitilliumWeb-Regular">{{'front_profil_ticket.you_have_no_future_event'| translate}}</h5>
              <a href="/" class="btn  TitilliumWeb-Regular"  style="padding-right: 15px" role="button" aria-pressed="true"><i class="fa fa-calendar" aria-hidden="true" style="margin-right: 5px;padding-left:15px;padding-right:5px;color: white!important;"></i>{{'front_profil_ticket.check_the_agenda'| translate}}</a>
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
</section>
